export const uploadFile = async ({ file, token }: { file: File; token: string | undefined }) => {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/files/upload/direct/start/`, {
    method: 'POST',
    redirect: 'follow',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify({
      file_name: file.name,
      file_type: file.type,
    }),
  })

  if (res.ok) {
    const awsData = await res.json()
    const formData = new FormData()
    Object.entries(awsData.fields).forEach(([key, value]) => {
      formData.append(key, value as string | Blob)
    })
    formData.append('file', file)
    const uploadRes = await fetch(awsData.url, {
      method: 'POST',
      redirect: 'follow',
      body: formData,
    })

    if (uploadRes.ok && uploadRes.status === 204) {
      const finishRes = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/files/upload/direct/finish/`, {
        method: 'POST',
        redirect: 'follow',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify({
          file_id: awsData.id,
        }),
      })

      if (finishRes.ok) {
        return finishRes.json()
      }
    }
  }
}
